<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{dialogTitle}}</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>

        <form [formGroup]="categoryForm" fxLayout="column" fxLayoutAlign="start"
              fxFlex="1 0 auto">

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Name'|translate}}</mat-label>
                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100">
                    <mat-label>{{'Parent category'|translate}}</mat-label>
                    <mat-select formControlName="parent">
                        <mat-option [value]="category.id" *ngFor="let category of categories">
                            {{category.name}}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix class="secondary-text">outlined_flag</mat-icon>
                </mat-form-field>
            </div>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

<!--        <button *ngIf="action === 'edit'"-->
<!--                mat-button-->
<!--                class="mr-8"-->
<!--                (click)="matDialogRef.close(['delete',categoryForm])"-->
<!--                aria-label="Delete"-->
<!--                matTooltip="Delete">-->
<!--            {{'DELETE'|translate}}-->
<!--        </button>-->

        <button *ngIf="action !== 'edit'"
                mat-button
                class="save-button"
                color="primary"
                (click)="matDialogRef.close(['save',categoryForm])"
                [disabled]="categoryForm.invalid"
                aria-label="SAVE">
            {{'ADD'|translate}}
        </button>

        <button *ngIf="action === 'edit'"
                mat-button
                class="save-button"
                (click)="matDialogRef.close(categoryForm)"
                [disabled]="categoryForm.invalid"
                aria-label="SAVE">
            {{'SAVE'|translate}}
        </button>

    </div>
</div>
